import { filterParams, picDataFormat } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


const KEYS = [
  'taxPayer',
  'taxPayerIdType',
  'taxId',
  'taxPics',
  'taxPaymentMethod',
  'taxPayerAddr',
  'taxVatPayment',
  'localTaxPayer',
  'localTaxPayerIdType',
  'localTaxId',
  'localTaxPayerAddr',
  'localTaxVatPayment',
  'localTaxPics',
  'localTaxPaymentMethod',
  'taxIdcif',
  'taxPayerIdcard',
  'taxPayerPostcode',
  'taxSourceType'
]

export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  let revertted = {}
  if (contractData) {
    revertted = pick(contractData, KEYS)
    revertted.taxPics = picDataFormat(revertted.taxPics, revertted.taxPics)
    revertted.localTaxPics = picDataFormat(revertted.localTaxPics, revertted.localTaxPics)
  }
  return revertted
}

export function submitFormat (contractGlobal) {
    return {
      params: JSON.stringify({
        queryId: this.$route.params.id,
        source: 'contractor',
        pathUrl: location.href,
        contractGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
